import { ReactElement, useState } from 'react';
import { SearchIconWhite } from '@root/src/assets/images';
import DataTiles from './dataTile/dataTiles';
import {
  MobileFlexRowContainer,
  MobileSearchButton,
  WrapContainer,
} from './styles';
import FiltersMobile from './filtersMobile';
import { FilterBarComponentI } from '.';

export const FilterBarMobile = ({
  stats,
  selectedStartDate,
  isActive,
  ordersStateChange,
  searchText,
  onChangeSearchText,
  onSetFilterDate,
  typeFilterOptions,
  handleChangeTestFilter,
  currentTestFilterOption,
}: FilterBarComponentI): ReactElement => {
  const [showFilters, setShowFilters] = useState(false);

  const handleHideFilters = () => {
    setShowFilters(false);
  };

  const handleShowFilters = () => {
    setShowFilters(true);
  };

  return (
    <>
      {showFilters ? (
        <FiltersMobile
          selectedStartDate={selectedStartDate}
          onChangeSearchText={onChangeSearchText}
          onSetFilterDate={onSetFilterDate}
          handleClose={handleHideFilters}
          searchText={searchText}
          handleChangeTestFilter={handleChangeTestFilter}
          typeFilterOptions={typeFilterOptions}
          currentTestFilterOption={currentTestFilterOption}
        />
      ) : (
        <WrapContainer>
          <MobileFlexRowContainer>
            <MobileSearchButton
              aria-label="search and filters"
              onClick={handleShowFilters}
            >
              <SearchIconWhite />
            </MobileSearchButton>
            <DataTiles
              stats={stats}
              isActive={isActive}
              ordersStateChange={ordersStateChange}
            />
          </MobileFlexRowContainer>
        </WrapContainer>
      )}
    </>
  );
};

export default FilterBarMobile;
